const STORAGE_KEY = "wave.syncDebugVisible";

function loadPref(): boolean {
  try {
    if (localStorage.getItem(STORAGE_KEY) != null) {
      return localStorage.getItem(STORAGE_KEY) === "1";
    }
  } catch {
    /* ignore */
  }
  return import.meta.env.DEV;
}

let showDiagnosticsBar = loadPref();
const listeners = new Set<() => void>();

function notify(): void {
  for (const fn of listeners) fn();
}

export function getWaveSyncDebugVisible(): boolean {
  return showDiagnosticsBar;
}

export function setWaveSyncDebugVisible(enabled: boolean): void {
  showDiagnosticsBar = enabled;
  try {
    localStorage.setItem(STORAGE_KEY, enabled ? "1" : "0");
  } catch {
    /* ignore */
  }
  notify();
}

export function subscribeWaveSyncDebugVisible(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
